import {
  amplitudeSendEvent,
  GTM_NOTSET_STRING,
  getScreenName,
  pushDataLayer,
} from '@musinsa/frontend-utils';
import { Label, Typography } from '@musinsa/mds';
import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import { track } from '@musinsa/packages-event-snowplow';
import type { FC } from 'react';
import { getPaths, useNavigate } from '../../../common';
import { SNOWPLOW_SCHEME } from '../../../snowplow';
import { CampaignIcon } from '../EarningsBoostIcons';
import { EarningsBoostItem } from './EarningsBoostItem';

const LINK_ID = 'join_campaign';
const LINK_TITLE = '시딩 캠페인 참여하기';
const LINK_TEXT = '모집 중인 캠페인에 참여해 보세요';

const NewLabel = () => (
  <Label variant="blueOpacity">
    <Typography size="11">신규</Typography>
  </Label>
);

interface JoinCampaignLinkProps {
  count?: number;
  className?: string;
}

export const JoinCampaignLink: FC<JoinCampaignLinkProps> = ({ count, className }) => {
  const { service } = useDeviceInfo();
  const { navigate } = useNavigate();
  const paths = getPaths(service);

  const handleClick = () => {
    if (service === SERVICE.MUSINSA) {
      amplitudeSendEvent({
        action_name: 'click',
        button_name: 'join_campaign',
        component_name: 'button',
        event_name: 'click_button',
        from: getScreenName(),
        name: 'campaign',
        section_name: 'mypage_dashboard',
      });
      pushDataLayer('click_button', {
        brand_id: GTM_NOTSET_STRING,
        button_id: 'join_campaign',
        button_name: 'campaign',
        index: GTM_NOTSET_STRING,
        section_index: '4',
        section_name: 'mypage_dashboard',
      });
    } else {
      track({
        schema: SNOWPLOW_SCHEME.CLICK_BUTTON,
        data: {
          page_name: 'curator_mypage',
          section_name: 'IncreaseMyRevenue',
          section_title: '나의 활동 관리',
          position: 4,
          button_id: LINK_ID,
          button_name: LINK_TITLE,
        },
      });
    }
    navigate(paths.campaignRecruitment());
  };

  return (
    <EarningsBoostItem
      icon={<CampaignIcon />}
      title={LINK_TITLE}
      titleLabel={<NewLabel />}
      text={LINK_TEXT}
      rightText={count !== undefined ? `${count}개` : undefined}
      onClick={handleClick}
      className={className}
    />
  );
};
